import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SignupShellComponent } from './signup-shell.component';
import { SignUpModule } from '../../../sign-up-process/sign-up.module';
import { SignupForgottenPasswordModule } from '../../../root/components/signup/signup.module';

@NgModule({
  declarations: [SignupShellComponent],
  imports: [CommonModule, SignUpModule, SignupForgottenPasswordModule]
})
export class SignupShellModule {}
